import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StaffPerson, StaffPersonSearchParams} from '@accounting/_common/models/staff-persons.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[StaffPersons] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffPerson[] } }>()
);

export const CheckStateSuccess = createAction(
    '[StaffPersons] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffPerson[] } }>()
);

export const LoadCategories = createAction(
    '[StaffPersons] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[StaffPersons] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[StaffPersons] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[StaffPersons] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[StaffPersons] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[StaffPersons] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[StaffPersons] Load List Success',
    props<{ payload: { items: StaffPerson[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[StaffPersons] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[StaffPersons] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[StaffPersons] Set Filter',
    props<{ payload: StaffPersonSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[StaffPersons] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[StaffPersons] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[StaffPersons] Update Item Success',
    props<{ payload: StaffPerson }>()
);

export const DeleteItem = createAction(
    '[StaffPersons] Delete Item',
    props<{ payload: StaffPerson }>()
);

export const DeleteItemSuccess = createAction(
    '[StaffPersons] Delete Item Success',
    props<{ payload: StaffPerson }>()
);

export const DeleteItemFailure = createAction(
    '[StaffPersons] Delete Item Failure',
    props<{ payload: StaffPerson }>()
);

export const SetInitialState = createAction(
    '[StaffPersons] Set Initial State'
);

export const UpdateStaffPersonItem = createAction(
    '[StaffPersons] Update StaffPerson Item',
    props<{ payload: StaffPerson }>()
);
